<template>
  <AntFormItem class="checkbox">
    <AntCheckbox
      v-bind="$attrs"
      v-on="checkboxListeners"
      v-decorator="[name, {
        rules: validationRules,
        preserve,
      }]"
    >
      <slot />
    </AntCheckbox>
  </AntFormItem>
</template>

<script>
import {
  Checkbox as AntCheckbox,
  Form as AntForm,
} from 'ant-design-vue';

export default {
  name: 'Checkbox',
  components: { AntCheckbox, AntFormItem: AntForm.Item },
  props: {
    name: {
      type: String,
      required: true,
    },
    preserve: {
      type: Boolean,
      default: true,
    },
    validationRules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    checkboxListeners() {
      const customListeners = { change: e => this.$emit('change', e.target.checked) };
      return { ...this.$$listeners, ...customListeners };
    },
  },
};
</script>

<style lang="scss">
  .checkbox {
    .ant-checkbox-wrapper {
      color: $primary !important;
      display: flex !important;
      font-size: 14px;
      letter-spacing: .2px;
      line-height: 1.43;
      margin-bottom: 5px;
    }

    input[type='checkbox'] {
      border-radius: 5px;
    }

    .ant-checkbox-inner {
      border-radius: 5px;
      border: 1.5px solid $accent !important;
      height: 22px;
      width: 22px;

      &::after {
        border-left: 0 !important;
        border-top: 0 !important;
        border: 1.5px solid $white;
        left: 30%;
        transform: rotate(45deg) scale(1.3) translate(-50%, -50%);
      }
    }

    .ant-checkbox {
      + span {
        margin-left: 18px;
        padding: 0;
      }

      &.ant-checkbox-checked {
        height: 22px;
        width: 22px;

        .ant-checkbox-inner {
          background-color: $accent;
        }
      }
    }

    .has-error {
      .ant-checkbox-inner {
        border: 1.5px solid $red !important;
      }
    }

    .ant-form-explain {
      color: $red !important;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: .17px;
    }
  }
</style>
